import request from "@/utils/request-axios";
import api from '@/utils/api'

//财粮说首页推荐
export function getQuotationRecommend(params) {
  return request(`${api.getQuotationRecommend}`, {
    loading: true,
    method: 'post',
    data: params
  });
}

//财粮说我的订阅
export function getQuotationSubscribe(params) {
  return request(`${api.getQuotationSubscribe}`, {
    loading: true,
    method: 'post',
    data: params
  });
}

//根据ID获取报价单详情
export function getQuotationDetails(params) {
  return request(`${api.getQuotationDetails}${params}`, {
    loading: true,
    method: 'get',
  });
}


//财粮说我的收藏的报价单
export function getMyCollect(params) {
  return request(`${api.getMyCollect}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//财粮说我的草稿
export function getMyDraft(params) {
  return request(`${api.getMyDraft}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//导入上一次的报价单
export function getLastQuotation(params) {
  return request(`${api.getLastQuotation}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//获取标签
export function getQuotationLabels(params) {
  return request(`${api.getQuotationLabels}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//创建报价单表格下拉框
export function getQuotationTitle(params) {
  return request(`${api.getQuotationTitle}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//创建报价单
export function addQuotation(params) {
  return request(`${api.addQuotation}`, {
    loading: true,
    method: 'post',
    data: params,
  });
}

//删除报价单
export function deleteQuotation(params) {
  return request(`${api.deleteQuotation}${params}`, {
    loading: true,
    method: 'delete',
    promptMessage: "删除报价单成功!",
  });
}

//收藏报价单
export function collectQuotation(params) {
  return request(`${api.collectQuotation}${params}`, {
    loading: true,
    method: 'post',
    promptMessage: "收藏报价单成功!",
  });
}

//取消收藏报价单
export function cancelCollectQuotation(params) {
  return request(`${api.cancelCollectQuotation}${params}`, {
    loading: true,
    method: 'put',
    promptMessage: "取消收藏成功!",
  });
}

//订阅报价单
export function subQuotation(params) {
  return request(`${api.subQuotation}${params}`, {
    loading: true,
    method: 'put',
    promptMessage: "订阅成功!",
  });
}

//取消订阅报价单
export function unSubQuotation(params) {
  return request(`${api.unSubQuotation}${params}`, {
    loading: true,
    method: 'put',
    promptMessage: "取消订阅成功!",
  });
}

//查询订阅和被订阅人数
export function searchSubscribe(params) {
  return request(`${api.searchSubscribe}`, {
    loading: true,
    method: 'get',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/dynamic/dynamicHome.js